import axios from "axios";
import { X } from "lucide-react";
// import { ImageWithFallback } from "./figma/ImageWithFallback";
import React, { useEffect, useState } from "react";

// ImageWithFallback component directly included
const ERROR_IMG_SRC =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg==";

function ImageWithFallback(props) {
  const [didError, setDidError] = useState(false);

  const handleError = () => {
    setDidError(true);
  };

  const { src, alt, style, className, ...rest } = props;

  return didError ? (
    <div
      className={`image-fallback-container ${className || ""}`}
      style={style}
    >
      <div className="fallback-content">
        <img
          src={ERROR_IMG_SRC}
          alt="Error loading image"
          {...rest}
          data-original-url={src}
        />
      </div>
    </div>
  ) : (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      {...rest}
      onError={handleError}
    />
  );
}

export function SelectedAgent({ agent, onRemove }) {
  return (
    <div className="selected-agent">
      <div className="selected-image-container">
        <div className="selected-image-wrapper">
          <ImageWithFallback
            src={agent.image}
            alt={agent.name}
            className="selected-agent-image"
          />
        </div>
      </div>

      <button
        onClick={() => onRemove(agent.id)}
        className="remove-button"
        aria-label={`Remove ${agent.name}`}
      >
        <X className="remove-icon" />
      </button>
    </div>
  );
}
